import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Clinic } from "pwapi";

import { getClinicPhone } from "./clinicUtils";

/**
 * Returns a JSX element with a phone icon and the clinic phone number, or null if no phone is available.
 */
export function ClinicPhoneDisplay({ clinic }: { clinic: Clinic }) {
  const phone = getClinicPhone(clinic);
  if (!phone) return null;
  return (
    <span>
      <FontAwesomeIcon
        icon={faPhone}
        style={{
          color: "var(--grey80)",
          fontSize: ".875em",
          marginRight: 4,
        }}
      />
      {phone}
    </span>
  );
}
